'use client'

import * as React from 'react'
import { TabContentDefaultWrapper } from '../../tab-content/wrapper'
import { BlockDiff } from '../../../components/diff/block-diff'
import { useBranchMergeDiff } from '../_hooks/use-merge-diff'
import { ConflictsWizard } from '../_hooks/use-active-conflicts-wizard'
import { BreadcrumbDashboard } from '../../explore/components/tabs/dashboard-breadcrumb'
import { Branch } from '@basehub/data/replicache/index'
import { EditorModeProvider } from '../../explore/components/editor-mode-provider'

export const BranchChangesTabContent = ({
  activeBlockId,
  ...props
}: ({ branch: Branch } | { crId: string }) & { activeBlockId: string }) => {
  const branchOrCrId =
    'branch' in props ? { branch: props.branch } : { crId: props.crId }
  const { diffResult, branch } = useBranchMergeDiff(branchOrCrId)
  const crId = branchOrCrId.branch ?? branchOrCrId.crId ?? null

  if (!branch) return null
  return (
    <>
      <BreadcrumbDashboard
        type="editor-diff"
        activeBlockId={activeBlockId}
        treeManager={diffResult.treeNew}
      />
      <div className="relative h-full flex">
        <EditorModeProvider value="read">
          <TabContentDefaultWrapper size="lg" fullHeight>
            <BlockDiff
              blockId={activeBlockId}
              diffResult={diffResult}
              diffTabPrefix={`merge:${crId}:`}
            />
            <div id="editor-filler" className="h-8" />
          </TabContentDefaultWrapper>
        </EditorModeProvider>
      </div>
      <div className="absolute z-20 bottom-20 left-1/2 -translate-x-1/2 flex items-center justify-center gap-2">
        <ConflictsWizard branch={branch} />
      </div>
    </>
  )
}
